export default __webpack_public_path__ + "static/media/blog_3.25022de6.png";